import React from "react";

import Banner from "./Banner/Banner";
import Management from "./Section 2 Management/Management";
import VisionMission from "./Section 3 Vision and Mission/VisionMission";
import Objectives from "./Section 4 Objectives/Objectives";
import DepartmentsandSubsidiaries from "./Section 5 Departments and Subsidiaries/DepartmentsandSubsidiaries";

const Ptc = () => {
  return (
    <>
      <Banner />
      <Management />
      <VisionMission />
      <Objectives />
      <DepartmentsandSubsidiaries />
    </>
  );
};

export default Ptc;
